
import { defineComponent, PropType } from 'vue'

import { RepoPerms, TeamPerms } from '~/types/permTypes'
import { TeamMemberRoleChoices } from '~/types/types'

import RepoDetailMixin from '~/mixins/repoDetailMixin'
import RoleAccessMixin from '~/mixins/roleAccessMixin'

export default defineComponent({
  name: 'RepoInactive',
  mixins: [RepoDetailMixin, RoleAccessMixin],

  props: {
    activateAnalysisLoading: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  computed: {
    canViewerUpgrade(): boolean {
      return this.$gateKeeper.team(TeamPerms.CHANGE_PLAN, this.teamPerms.permission)
    },
    configNotAdded(): boolean {
      return this.repository.errorCode === 3001
    },
    noticeTitle(): string {
      if (!this.canActivateRepo) {
        return 'This repository is not activated'
      }

      if (this.repository.canBeActivated || this.repository.isActivated) {
        return 'Activate analysis on this repository'
      }

      if (this.canViewerUpgrade) {
        return 'Upgrade to activate this repository'
      }

      return 'Repository cannot be activated'
    },
    canActivateRepo(): boolean {
      const role = this.activeDashboardContext.role as TeamMemberRoleChoices
      return (
        this.$gateKeeper.team(TeamPerms.ACTIVATE_ANALYSIS, role) ||
        this.$gateKeeper.repo(RepoPerms.ACTIVATE_REPOSITORY, this.repoPerms.permission)
      )
    },
    canRequestRepoActivation(): boolean {
      return this.$gateKeeper.repo(RepoPerms.READ_REPO, this.repoPerms.permission)
    }
  }
})
